module.exports = __webpack_public_path__ + "static/media/twitter.08d2ade8.svg";